import React, {useEffect, useState} from "react";
import {setSimulateurObject} from "../../../actions/simulateur.action";
import {useDispatch} from 'react-redux';
import {styles} from "../../../stylesheets/simulateurs.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import ButtonDroitpartage from "../../../components/buttons/button.droitpartage";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";

// Partage de biens indivis, régime ORDINAIRE (en cas d'indivision conventionnelle ou indivision entre concubins, un leg ou une donation entre vifs)
// ID 61

function Simulateur_A1_21bis(props, simulateur, isParent, departements) {

    let currUser = JSON.parse(localStorage.getItem("efluser"));
    let currUserDep = 0
    if (currUser.societe_zip.startsWith("97")){
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 3);
        currUserDep = parseInt(trimedZip)
    } else {
        let trimedZip;
        trimedZip = currUser.societe_zip.slice(0, 2);
        currUserDep = parseInt(trimedZip)
    }

    const dispatch = useDispatch();
    const [departement, setDepartement] = useState(0)
    const [masse_brute, setMasseBrute] = useState(0)
    const [actif_net, setActifNet] = useState(0)
    const [montant_soulte, setSoulte] = useState(0)
    const [montant_passif, setPassif] = useState(0)
    const [valeur_cumulee, setValeurCumulee] = useState(0)

    const handleChange = async (setter, value) => {
        if (setter === setDepartement) {
            setDepartement(parseInt(value))
        } else setter(value);
        setInRedux(setter, value)
    };

    const handleChangeRemarque = async (value) => {
        localStorage.setItem("remarque", value)
    }

    function setInRedux(setter, value) {
        if (props.isParent) {

            let object = {
                "simulateurid": props.simulateur.id,
                "departementid": 0,
                "bureauid": parseInt(currUser.id),
                "inputs": {}
            };

            if (setter === setDepartement) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(masse_brute)})
                Object.assign(object['inputs'], {'actif_net': parseInt(actif_net)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(montant_soulte)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(montant_passif)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(valeur_cumulee)})
                object.departementid = parseInt(value)
            }

            if (setter === setMasseBrute) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(value)})
                Object.assign(object['inputs'], {'actif_net': parseInt(actif_net)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(montant_soulte)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(montant_passif)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(valeur_cumulee)})
                object.departementid = parseInt(departement)
            }

            if (setter === setActifNet) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(masse_brute)})
                Object.assign(object['inputs'], {'actif_net': parseInt(value)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(montant_soulte)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(montant_passif)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(valeur_cumulee)})
                object.departementid = parseInt(departement)
            }

            if (setter === setSoulte) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(masse_brute)})
                Object.assign(object['inputs'], {'actif_net': parseInt(actif_net)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(value)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(montant_passif)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(valeur_cumulee)})
                object.departementid = parseInt(departement)
            }

            if (setter === setPassif) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(masse_brute)})
                Object.assign(object['inputs'], {'actif_net': parseInt(actif_net)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(montant_soulte)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(value)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(valeur_cumulee)})
                object.departementid = parseInt(departement)
            }

            if (setter === setValeurCumulee) {
                Object.assign(object['inputs'], {'masse_brute': parseInt(masse_brute)})
                Object.assign(object['inputs'], {'actif_net': parseInt(actif_net)})
                Object.assign(object['inputs'], {'montant_soulte': parseInt(montant_soulte)})
                Object.assign(object['inputs'], {'montant_passif': parseInt(montant_passif)})
                Object.assign(object['inputs'], {'valeur_cumulee': parseInt(value)})
                object.departementid = parseInt(departement)
            }

            dispatch(setSimulateurObject(object));

        } else {

            // process child simu

        }
    }


    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id}/>
                
                <TextfieldRemarques handleChange={handleChangeRemarque}/>

                {props?.isParent === true && props.departements !== "" ?
                    <>
                        <div style={styles.cardRow}>
                            <div style={styles.cardElemVerticalyCenter}>Département :</div>

                            <SelectDepartement
                                items={props.departements}
                                nameField={"name"}
                                defaultValue={currUserDep}
                                optionValue={"id"}
                                handleChange={handleChange}
                                setter={setDepartement}
                            />
                        </div>
                        <div style={styles.cardRowSpecialMessage}>
                            La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
                        </div>
                    </>
                    :
                    <></>
                }

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quelle est la masse brute partagée (immeubles et meubles) ou Actif Brut ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Actif brut"}
                        setter={setMasseBrute}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quel est l’Actif Net partagé ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Actif net"}
                        setter={setActifNet}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quel est le montant de la soulte ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Montant de la soulte"}
                        setter={setSoulte}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quel est le montant du passif pris en charge par un des copartageants ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Montant du passif"}
                        setter={setPassif}
                    />
                </div>

                <div style={styles.cardRow}>
                    <div style={styles.cardElemVerticalyCenter}>
                        Quelle est la valeur cumulée des biens immobiliers partagés ?
                    </div>
                    <TextfieldNumber
                        handleChange={handleChange}
                        type={"number"}
                        placeholder={"Valeur"}
                        setter={setValeurCumulee}
                    />
                </div>
            </div>
        </div>
    )
}

export default Simulateur_A1_21bis;
